import { Controller } from "@hotwired/stimulus"
import {
  browserSupportsWebAuthn,
  browserSupportsWebAuthnAutofill,
  startAuthentication,
  WebAuthnAbortService
} from "@simplewebauthn/browser"
import { postJSON, PasskeyRequestError, isAbort, isCancel } from "../src/passkey_api"

// パスキーログイン。
// - ボタン(login アクション): その場で端末のパスキー選択を出す
// - autofill 値が true: メール欄のオートフィル候補にパスキーを出す(Conditional UI)。
//   対象の input には autocomplete="username webauthn" が要る
// 非対応ブラウザではボタンを隠したまま(hidden)にする。
export default class extends Controller {
  static targets = ["button", "error"]
  static values = {
    optionsUrl: String,
    loginUrl: String,
    autofill: Boolean,
    failedMessage: String,
    cancelledMessage: String
  }

  connect() {
    if (!browserSupportsWebAuthn()) return

    this.buttonTargets.forEach(button => { button.hidden = false })
    if (this.autofillValue) this.startAutofill()
  }

  disconnect() {
    WebAuthnAbortService.cancelCeremony()
  }

  async login(event) {
    event.preventDefault()
    this.clearError()
    await this.authenticate({ useBrowserAutofill: false })
  }

  async startAutofill() {
    if (!(await browserSupportsWebAuthnAutofill())) return

    await this.authenticate({ useBrowserAutofill: true })
  }

  async authenticate({ useBrowserAutofill }) {
    try {
      const optionsJSON = await postJSON(this.optionsUrlValue)
      const credential = await startAuthentication({ optionsJSON, useBrowserAutofill })
      const { redirect_url: redirectUrl } = await postJSON(this.loginUrlValue, { credential })
      window.location.assign(redirectUrl)
    } catch (error) {
      this.handleError(error)
    }
  }

  handleError(error) {
    if (isAbort(error)) return
    if (isCancel(error)) return this.showError(this.cancelledMessageValue)
    if (error instanceof PasskeyRequestError && error.message) return this.showError(error.message)

    this.showError(this.failedMessageValue)
  }

  showError(message) {
    if (!this.hasErrorTarget) return

    this.errorTarget.textContent = message
    this.errorTarget.hidden = false
  }

  clearError() {
    if (!this.hasErrorTarget) return

    this.errorTarget.textContent = ""
    this.errorTarget.hidden = true
  }
}
